"use client";

import Script from "next/script";

declare global {
  interface Window {
    lenis: any;
  }
}

const SmoothScroller = () => {
  return (
    <Script
      src="https://unpkg.com/lenis@1.1.5/dist/lenis.min.js"
      onReady={() => {
        // @ts-ignore
        const lenis = new window.Lenis();
        
        // Attach the instance to the window object
        window.lenis = lenis;

        function raf(time: number) {
          lenis.raf(time);
          requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }}
    />
  );
};

export default SmoothScroller;
